module.exports = __webpack_public_path__ + "static/media/ico_refresh.386a1a43.svg";